// All values in file are retured from API
export const SIGNAL_TRANSLATION_BOOLEAN_TYPES = Object.freeze({
  OFF: 'off',
  ON: 'on',
  RELEASED: 'released',
  PRESSED: 'pressed',
  SET: 'set',
  DISENGAGED: 'disengaged',
  ENGAGED: 'engaged',
  OPEN: 'open',
  LATCHED: 'latched',
  UNLOCKED: 'unlocked',
  LOCKED: 'locked',
  PLUS_12_VOLTS: '+12v',
  GROUNDED: 'grounded',
  ACTIVATED: 'activated',
  DEACTIVATED: 'deactivated',
  ERROR: 'error',
  NO_ERROR: 'no error',
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  NOT_AVAILABLE: 'not available',
})

export const SIGNAL_TRANSLATION_STATE_TYPES = Object.freeze({
  OFF: 'off',
  ACCESSORY: 'accessory',
  RUN: 'run',
  CRANK: 'crank',
  REVERSE: 'reverse',
  NEUTRAL: 'neutral',
  GEAR_1: 'gear 1',
  GEAR_2: 'gear 2',
  GEAR_3: 'gear 3',
  GEAR_4: 'gear 4',
  GEAR_5: 'gear 5',
  GEAR_6: 'gear 6',
  LEVEL_0: 'level 0',
  LEVEL_1: 'level 1',
  LEVEL_2: 'level 2',
  LEVEL_3: 'level 3',
  LEVEL_4: 'level 4',
  LEVEL_5: 'level 5',
  LEVEL_6: 'level 6',
  LEVEL_7: 'level 7',
  LEVEL_8: 'level 8',
  LEVEL_9: 'level 9',
  LEVEL_10: 'level 10',
  LEVEL_11: 'level 11',
  LEVEL_12: 'level 12',
  LEVEL_13: 'level 13',
  PARK: 'park',
  UNAVAILABLE: 'unavailable',
  SINGLE_RUN: 'single run',
  SINGLE_RUN_TIMER: 'single run timer',
  REPEATING: 'repeating',
  REPEATING_TIMER: 'repeating timer',
  DISABLED: 'disabled',
  NOT_AVAILABLE: 'sna',
  ERROR: 'error',
  ACTIVATED: 'activated',
  DEACTIVATED: 'deactivated',
  RELEASED: 'released',
  DEPRESSED: 'depressed',
  MARKER_ON: 'marker on',
  HEADLIGHTS_ON: 'headlights on',
  HEADLIGHTS_MARKER_ON: 'headlights and markers on',
  AUTO: 'auto',
  DELAYED_OFF: 'delayed off',
  TRAILER_DETECTED: 'trailer detected',
  TRAILER_NOT_DETECTED: 'trailer not detected',
  TRAILER_ALARM: 'trailer alarm',
  INTERMITTENT_1: 'intermittent 1',
  INTERMITTENT_2: 'intermittent 2',
  INTERMITTENT_3: 'intermittent 3',
  INTERMITTENT_4: 'intermittent 4',
  INTERMITTENT_5: 'intermittent 5',
  LOW: 'low',
  HIGH: 'high',
  RESERVED_FOR_SAE: 'reserved for SAE',
  ON_SOLID: 'on solid',
  ON_FAST_BLINK: 'on fast blink',
})

export const SIGNAL_TRANSLATION_RANGE_LABELS = Object.freeze({
  MPH: 'MPH',
  RPM: 'RPM',
  V: 'V',
  OHM: 'OHM',
  KOHM: 'KOHM',
  PERCENT: '%',
  FAHRENHEIT: 'F',
  kPa: 'kPa',
})

export const SIGNAL_TRANSLATION_IDS = Object.freeze({
  STATE_IGNITION: 'state_ignition',
})
